import { render, staticRenderFns } from "./PcnShortcuts.vue?vue&type=template&id=45e8c315"
import script from "./PcnShortcuts.vue?vue&type=script&lang=js"
export * from "./PcnShortcuts.vue?vue&type=script&lang=js"
import style0 from "./PcnShortcuts.vue?vue&type=style&index=0&id=45e8c315&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports